import cx from 'classnames';

import { isNewSong } from '../../helpers/songDates';
import { normalizeKeyDisplay } from '../../utils/diatonicChords';
import { getSetting, settingKeys } from '../../utils/settings';

import Icon from '../common/Icon';
import { SongLength } from '../common/ServiceLength';
import { ReactComponent as MusicIcon } from '../../icons/album-list.svg';
import { ReactComponent as XmarkIcon } from '../../icons/xmark.svg';

function ServiceSong({ onDeleteSong, song, seconds }) {
  const isNew = isNewSong(song.createdAt, song.isNewSong);
  const preferSharps = getSetting(settingKeys.preferSharps) ?? true;
  const categoryClass = isNew ? 'new' : song.category.name === 'Praise' ? 'praise' : 'worship';

  return (
    <li className="song">
      {/* The category's round badge doubles as the handle the list is dragged by */}
      <span className={cx('category', 'drag-handle', categoryClass)}>
        <Icon icon={<MusicIcon />} />
      </span>
      <div className="info">
        <div className="title text-ellipsis">{song.title}</div>
        <div className="artist text-ellipsis">{song.artist}</div>
        <SongLength seconds={seconds} className="length" />
      </div>
      <div className="meta">
        <span className="key">{normalizeKeyDisplay(song.key, preferSharps)}</span>
        {song.bpm && <span className="bpm">{song.bpm}</span>}
      </div>
      <button type="button" className="remove" aria-label={`Remove ${song.title}`} onClick={() => onDeleteSong(song)}>
        <Icon icon={<XmarkIcon />} />
      </button>
    </li>
  );
}

export default ServiceSong;
